export const META_TYPE = 'riskProfile';
export const META_VER = 'v1';

export const CMD_RISKPROFILE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
